import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Formats "YYYY-MM-DD" snapshot days. They are calendar days, not instants, so they are read as
 * UTC midnights and formatted in UTC; the store timezone would shift them a day for stores west
 * of Greenwich.
 */
export function useDayFormat() {
  const { i18n } = useTranslation();
  return useMemo(() => {
    const short = new Intl.DateTimeFormat(i18n.language, {
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    });
    const medium = new Intl.DateTimeFormat(i18n.language, {
      dateStyle: 'medium',
      timeZone: 'UTC',
    });
    const asDate = (day: string) => new Date(`${day}T00:00:00Z`);
    return {
      short: (day: string) => short.format(asDate(day)),
      medium: (day: string) => medium.format(asDate(day)),
      range: (from: string, to: string) =>
        from === to ? medium.format(asDate(from)) : medium.formatRange(asDate(from), asDate(to)),
    };
  }, [i18n.language]);
}
